import Vue from 'vue';
import Router from 'vue-router'
import Index from './views/Index.vue'

Vue.use(Router)

export default [
    {
        path: '/',
        name: 'Home Page',
        component: Index
    },
    {
        path: '/lodge/:id',
        name: 'Single Lodge',
        component: () => import('./views/Lodge.vue')
    },
    {
        path: '/lodges',
        name: 'General listing page',
        component: () => import('./views/Lodges.vue')
    },
    {
        path: '/profile',
        name: 'Profile Page',
        component: () => import('./views/Profile.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/terms',
        name: 'Terms and Conditions',
        component: () => import('./views/Terms.vue'),
    },
    {
        path: '/policy',
        name: 'Our Policy',
        component: () => import('./views/Policy.vue'),
    },
    {
        path: "*",
        name: '404',
        component: () => import('./views/404.vue')
    }
]